export default __webpack_public_path__ + "static/stablecoin-purple-e787ae8d0ff4adef271e1bba0307c050.svg";